import React, { FC } from 'react';
import './ImageLoader.css';

interface ImageLoaderProps {}

const ImageLoader: FC<ImageLoaderProps> = () => (
  <div className="ImageLoader" data-testid="ImageLoader">
    <div className="spinner" />
  </div>
);

export default ImageLoader;